import React, { useState, useEffect, useContext, createRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import SEO from "../Components/SEO";

import { FaTimes } from "react-icons/fa";

import UserContext from "../UserContext";

const Alert = ({ color, message }) => {
  const [status, setStatus] = useState("show");

  const removeAlert = () => {
    setStatus("hide");
  };

  if (status === "show")
    return (
      <div
        className={
          "py-3 px-4 mb-4 shadow-sm border-2 border-l-8 border-" +
          color +
          "-400 border-r-0 flex justify-content-between align-items-center"
        }
        // style={{ minWidth: "20rem" }}
      >
        <span className={"text-sm text-" + color + "-700"}>{message}</span>
        <button
          className={
            "bg-" +
            color +
            "-500 p-1 ml-4 rounded-full focus:ring focus:ring-" +
            color +
            "-200"
          }
          onClick={removeAlert}
        >
          <FaTimes color="white" />
        </button>
      </div>
    );
  else return <></>;
};

const MyAlert = ({ error, success }) => {
  if (success) {
    return <Alert color="green" message={success} />;
  } else if (error) return <Alert color="red" message={error} />;
  else return <></>;
};

export default function WordPuzzleGamePage() {
  const { mode, user } = useContext(UserContext);
  let keyboardRef = createRef();
  // setting the theme
  const [dark, setDark] = useState(false);
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  const history = useHistory();
  const location = useLocation();
  if (!user?.token) {
    history.push(`/login?redirect_url=${location.pathname}${location.search}`);
  }

  const [layoutName, setlayoutName] = React.useState("default");
  const [input, setinput] = React.useState("");
  const [displayWord, setdisplayWord] = React.useState("");
  const [word, setword] = React.useState("");
  const [remainingAttempts, setremainingAttempts] = React.useState(0);
  const [remainingCharacters, setremainingCharacters] = React.useState(0);
  const [error, seterror] = React.useState("");
  const [success, setsuccess] = React.useState("");
  const [activeCategory, setactiveCategory] = React.useState("");

  const onChange = (input) => {
    let value = input[input.length - 1] || "";
    setinput(value);
    keyboardRef.current = value;
    if (value) guess(word, value);
  };

  const onKeyPress = (button) => {
    // console.log("Button pressed", button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" || button === "{lock}") handleShift();
  };

  const handleShift = () => {
    setlayoutName(layoutName === "default" ? "shift" : "default");
  };

  // const onChangeInput = (event) => {
  //   const input = event.target.value || "";
  //   if (!input) {
  //     onChange("");
  //   } else {
  //     for (let i = 0; i < input.length; i++) {
  //       onChange(input[i]);
  //     }
  //   }
  // };

  const { words } = require("../data/words.js");
  const { countries } = require("../data/countries.js");
  const { animals } = require("../data/animals.js");
  const { colors } = require("../data/colors.js");
  const { districts } = require("../data/districts.js");

  function findGuessWord(arr) {
    const index = Math.floor(Math.random() * arr.length || 274937);
    let tempword = arr[index];
    let tempremainingAttempts = tempword.length * 2;
    let tempremainingCharacters = tempword.length - 1;
    setremainingAttempts(tempremainingAttempts);
    setremainingCharacters(tempremainingCharacters);
    setword(tempword);
    return tempword;
  }

  function guess(guessWord, input) {
    if (remainingCharacters <= 0 || remainingAttempts <= 0) {
      if (remainingAttempts <= 0) {
        console.log("failed");
      }
      return false;
    }

    if (displayWord.includes(input)) {
      console.log("Letter already revealed");
      return;
    }

    input = input.toLowerCase();
    const index = guessWord.indexOf(input);
    if (index === -1) {
      setremainingAttempts(remainingAttempts - 1);
      return false;
    }
    let tempDisplayWord = displayWord;
    let tempremainingCharacters = remainingCharacters;
    for (const i in guessWord) {
      if (guessWord[i] === input && tempDisplayWord[i] === "-") {
        let splitTempDisplayWord = tempDisplayWord.split("");
        splitTempDisplayWord[i] = input;
        tempDisplayWord = splitTempDisplayWord.join("");
        tempremainingCharacters--;
        setdisplayWord(tempDisplayWord);
        setremainingCharacters(tempremainingCharacters);
        if (tempremainingCharacters <= 0) {
          seterror("");
          setsuccess(
            `🤪🤪 You won the game with ${remainingAttempts} 😋👏 trials remaining`
          );
        }
        // return true;
      }
    }
    // return false;
  }

  function changeWord() {
    let choosenWords =
      activeCategory === "Countries"
        ? countries
        : activeCategory === "Animals"
        ? animals
        : activeCategory === "Colour"
        ? colors
        : activeCategory === "Districts"
        ? districts
        : words;
    choosenWords = choosenWords.map((word) => word.toLowerCase());
    const word = findGuessWord(choosenWords);
    const index = Math.floor(Math.random() * word.length);
    // console.log(word);
    let tempDisplayWord = "";
    for (const i in word) {
      // tempDisplayWord += parseInt(i) !== index ? "-" : word[i];
      tempDisplayWord += word[parseInt(i)] !== word[index] ? "-" : word[i];
    }
    let tempremainingCharacters =
      tempDisplayWord.length - (tempDisplayWord.split(word[index]).length - 1);
    setremainingCharacters(tempremainingCharacters);
    seterror("");
    setsuccess("");
    setinput("");
    setdisplayWord(tempDisplayWord);
  }

  React.useEffect(() => {
    changeWord();
    // eslint-disable-next-line
  }, [activeCategory]);

  React.useEffect(() => {
    if (remainingAttempts <= 0 && remainingCharacters > 0) {
      seterror(
        `🤧🤭😶 You failed to guess '${word}' 🤣🤌  with ${remainingCharacters} characters remaining`
      );
    }
  }, [remainingAttempts, remainingCharacters, word]);

  const categoriesOptions = [
    { value: "", label: "All" },
    { value: "Animals", label: "Animals" },
    { value: "Countries", label: "Countries" },
    { value: "Districts", label: "Districts Of Rwanda" },
    // { value: "Colour", label: "Colour" },
    // { value: "City", label: "City" },
  ];

  const handleCategoryChange = (e) => {
    setactiveCategory(e.target.value);
  };

  const [instructions, toggleInstructions] = useState(false);
  return (
    <>
      <SEO title={`Word Puzzle Game`}></SEO>
      <div
        className="my-8 flex flex-column items-center word-puzzle-container"
        style={{ paddingBottom: 80 }}
      >
        <div className="word-puzzle-info relative">
          {instructions && (
            <div
              className={`${
                dark ? "divbg-in-darkmode " : "bg-white "
              }shadow absolute min-h-full top-10 md:top-24 left-0  px-3 py-5 w-3/4 ml-2 md:ml-0 md:w-1/2`}
            >
              <div className="flex justify-between">
                <h2 className="text-base font-bold">Instructions</h2>

                <button
                  className="text-xs  font-mono italic hover:text-white hommy--btn rounded px-2 py-1 mr-3 hover:opacity-80 no-underline"
                  onClick={() => toggleInstructions(false)}
                >
                  Close
                </button>
              </div>
              <div className="p-0.5 bg-fire w-1/3"></div>

              <p className="my-3">
                <ul className="list-disc px-3">
                  <li>Select the category (Default: All)</li>
                  <li>Use the Game keyboard to enter the characters</li>
                  <li>😀Have fun and win!!</li>
                </ul>
              </p>
            </div>
          )}
          <div className="flex">
            <h2 className="title font-bold text-xl md:text-3xl">
              🤪 Word <span className="text-fire">Puzzle</span>
            </h2>
            <sup>
              <span
                className="bg-fire hover:opacity-50 cursor-pointer w-5 h-5 flex justify-center items-center text-white rounded-full"
                onClick={() => toggleInstructions(!instructions)}
              >
                ?
              </span>
            </sup>
          </div>
          <div className="flex flex-column items-center gap-2 my-2 md:my-0">
            <span className="text-base">Remaining Trials</span>
            <span className="font-weight-bold text-xl md:text-2xl rounded-full bg-fire w-12 h-12 flex items-center justify-center text-white">
              {remainingAttempts}
            </span>
          </div>
          <div className="flex gap-4 items-end">
            <div
              className={`w-40 outline-none py-2 border ${
                dark ? "choose-category dark" : "choose-category"
              }`}
            >
            
              <select onChange={handleCategoryChange} className="px-4" value={activeCategory}>
                {categoriesOptions.map((c) => (
                  <option key={c.value} value={c.value}>
                    {c.label}
                  </option>
                ))}
              </select>
              </div>
            <button
              className={`px-4 py-2 rounded-md bg-fire text-white flex items-center justify-center`}
              onClick={changeWord}
            >
              Change Word
            </button>
          </div>
        </div>

        <div
          className={`word-container ${
            dark ? "myDarkTheme shadow-sm divbg-in-darkmode" : ""
          }`}
        >
          {displayWord.split("").map((character, index) => {
            return (
              <div key={index} className="character-container">
                {character === "-" ? "-" : character}
              </div>
            );
          })}
        </div>
        <MyAlert error={error} success={success} />
        <div className="simple-keyboard-container">
          <input
            value={input}
            placeholder={"Tap on the virtual keyboard to start"}
            // onChange={onChangeInput}
            className={`keyboard-input ${dark ? "dark" : ""}`}
            readOnly
          />
          <Keyboard
            theme={`hg-theme-default ${
              dark ? "myDarkTheme shadow-sm divbg-in-darkmode" : ""
            }`}
            keyboardRef={(r) => (keyboardRef = r)}
            layoutName={layoutName}
            onChange={onChange}
            onKeyPress={onKeyPress}
            layout={{
              default: [
                "1 2 3 4 5 6 7 8 9 0",
                "q w e r t y u i o p",
                "{lock} a s d f g h j k l",
                "{shift} z x c v b n m {shift}",
                "{space}",
              ],
              shift: [
                "~ ! @ # $ % ^ & * ( )",
                "Q W E R T Y U I O P { } |",
                "{lock} A S D F G H J K L {enter}",
                "{shift} Z X C V B N M {shift}",
                "{space}",
              ],
            }}
          />
        </div>
      </div>
    </>
  );
}
